import React, { useState, useRef, useEffect, useCallback } from 'react';
import { ReactComponent as RecordIcon } from "../icons/recording.svg";
import styles from './AudioRecordingAI.scss';
import { useVolumeMeter } from '../misc/useVolumeMeter';
import { useVAD } from '../chat/AIChatContext';
import { Body1, Caption1 } from '@fluentui/react-text';

const headerSpanStyles = {
textAlign: 'center',
fontWeight: 600,
lineHeight: 'var(--Line-height-300, 20px)' // 142.857%
};

const headerTextStyles = {
  overflow: 'hidden',
  color: 'var(--Gray-4, #BDBDBD)',
  textAlign: 'center',
  fontSize: 'var(--Font-size-200, 12px)',
  fontWeight: 400,
  lineHeight: 'var(--Line-height-200, 16px)' // 133.333%
};

 export function AudioSphereAIListeningStatus({receiver, scene, micActive}) {
    const initialInnerCircleSize = 150
    const [innerCircleSize, setInnerCircleSize] = useState(initialInnerCircleSize);

    const [level, setLevel] = useState(1);
    const levelRef = useRef(level);  // Create a ref to store the latest level

    const { scriptsLoaded } = useVAD();


    const update = useCallback(level => {
        const scaledLevel = level * 2;
        setLevel(scaledLevel);
        levelRef.current = scaledLevel;
    }, []);

    useVolumeMeter({
        analyser: scene.systems["hubs-systems"].audioSystem.outboundAnalyser,
        update
    });
    

    const receiverRef = useRef(null);
    receiverRef.current = receiver;

    useEffect(() => {
            if(micActive) {
                const normalizeCircle = levelRef.current * 50;

                const innerSize = Math.max(150, 150 + (normalizeCircle));

                setInnerCircleSize(innerSize);
            } else {
                setInnerCircleSize(initialInnerCircleSize);
            }

    }, [level]);


    return (
            <div id="ai-audio-listener" className={styles.endRecordButton} style={{paddingBottom: "46px", minHeight: "260px"}}>
                {/* <div className="audio-circle inner-circle" style={{ width: innerCircleSize, height: innerCircleSize }}></div> */}
                {!scriptsLoaded && <span>Loding Voice Listener...</span>}
                {scriptsLoaded && 
                <div style={{display: "flex", flexDirection: "column"}}>

                    <Body1 style={headerSpanStyles}>Talk or chat with our AI Bot</Body1>
                    <Caption1 style={headerTextStyles}>Hello, how can I help you today?</Caption1>
                </div>}
                <div className='audio-button-speaker'>
                    <div className='audio-button audio-circle' style={{ width: innerCircleSize, height: innerCircleSize }}></div>
                </div>
                {!document.hasFocus() && (<Body1 style={{textAlign: "center"}}>Current tab is not focused. Please click here to receive and send prompts by voice with AI</Body1>)}
            </div>

    );
};

export function RecordButtonInput({recording, setRecording}) {
    return (
        <div className={styles.recordButton} onClick={recording ? () => setRecording(false) : () => setRecording(true)}>
            <RecordIcon/>
        </div>
    );
}